import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const NotificationRoutes = defineRoute({
    latest: {
        route: {
            path: "/notification",
            component: () => loadView(import("./NotificationLatest.vue")),
        },
    },
    send: {
        route: {
            path: "/notification/send",
            component: () => loadView(import("./NotificationSend.vue")),
        },
    },
});
